/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import VehicleData from "../../components/vehicleData";
import ClientData from "../../components/clientData";
import InputChecklist from "../../components/inputChecklist";
import DetailedChecklist from "../../components/detailedChecklist";
import GlobalSVG from "../../utils/GlobalSVG";
import Services from "../../components/services";
import OrderOfService from "../../components/orderOfService";

function CreateFastService() {
  const [step, setStep] = useState(1)

  useEffect(() => {
    if (!localStorage.getItem('yc_usr_dt_ls')) {
      window.location.href = '/login';
  }
  }, [])

  const nextStep = (n) => {
    setStep(n)
  }


  return (

    <div className="flex flex-col self-stretch px-20 pt-8 pb-12 max-md:px-5">
      <div className="flex flex-col justify-center items-start py-4 pr-16 pl-6 text-xl font-medium leading-7 whitespace-nowrap bg-white rounded-sm shadow-sm text-black text-opacity-80 max-md:px-5 max-md:max-w-full">
        <Link to={"../dashboard"} className="flex gap-4 py-1.5">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/41d4a6552010f9660b25c3694ac8865e83e7186fa1d63626d3382babbc2b5165?"
            className="my-auto w-4 aspect-square"
          />
          <div className="grow">Criar nova ordem de serviço</div>
        </Link>
      </div>
      <div className="flex flex-col justify-center px-16 py-6 mt-6 text-base leading-6 bg-white rounded-sm shadow-sm max-md:px-5 max-md:max-w-full">
        {step < 6 && <div className="flex gap-4 self-stretch flex-start py-6 px-20 justify-center mx-4 max-md:flex-wrap max-md:mr-2.5 max-md:max-w-full">
          <div className="flex gap-2 w-auto items-center">
            <div className={`flex justify-center items-center text-white whitespace-nowrap aspect-square rounded-[32px] ${step > 1 ? "" : "bg-lime-700"} border border-solid border-[color:var(--Polar-Green-7,#389E0D)]`}>
              {step > 1 ? <div className="flex justify-center items-center h-8 w-8 rounded-full">{GlobalSVG.checked()}</div> : < div className="flex justify-center items-center h-8 w-8 rounded-full">
                1
              </div>
              }
            </div>
            <div className="self-stretch my-auto text-black text-opacity-80">
              Dados do veículo
            </div>
            <div className="flex justify-center items-center">
              {GlobalSVG.line(step > 1 ? "#389E0D" : null)}
            </div>
          </div>

          <div className="flex gap-2 items-center">
            <div className={`flex justify-center items-center whitespace-nowrap aspect-square rounded-[32px] border border-solid ${step > 2 ? "text-black text-opacity-30 border-[color:var(--Polar-Green-7,#389E0D)]" : step === 2 ? "bg-lime-700 text-white border border-solid border-[color:var(--Polar-Green-7,#389E0D)]" : "text-black text-opacity-30"} `}>
              {step > 2 ?
                <div className="flex justify-center items-center h-8 w-8 rounded-full">{GlobalSVG.checked()}</div> :
                < div className="flex justify-center items-center h-8 w-8 rounded-full">
                  2
                </div>
              }
            </div>
            <div className="flex-auto self-stretch my-auto text-black text-opacity-50">
              Dados do cliente
            </div>
            <div className="flex justify-center items-center">
              {GlobalSVG.line(step > 2 ? "#389E0D" : null)}
            </div>
          </div>
          <div className="flex gap-2 items-center">
            <div className={`flex justify-center items-center whitespace-nowrap aspect-square rounded-[32px] border border-solid ${step > 3 ? "text-black text-opacity-30 border-[color:var(--Polar-Green-7,#389E0D)]" : step === 3 ? "bg-lime-700 text-white border border-solid border-[color:var(--Polar-Green-7,#389E0D)]" : "text-black text-opacity-30"} `}>
              {step > 3 ? <div className="flex justify-center items-center h-8 w-8 rounded-full">{GlobalSVG.checked()}</div> : < div className="flex justify-center items-center h-8 w-8 rounded-full">
                3
              </div>
              }
            </div>
            <div className="flex-auto self-stretch my-auto text-black text-opacity-50">
              Checklist de entrada
            </div>
            <div className="flex justify-center items-center">
              {GlobalSVG.line(step > 3 ? "#389E0D" : null)}
            </div>
          </div>

          <div className="flex gap-2 items-center ">
            <div className={`flex justify-center items-center whitespace-nowrap aspect-square rounded-[32px] border border-solid ${step > 4 ? "text-black text-opacity-30 border-[color:var(--Polar-Green-7,#389E0D)]" : step === 4 ? "bg-lime-700 text-white border border-solid border-[color:var(--Polar-Green-7,#389E0D)]" : "text-black text-opacity-30"} `}>
              {step > 4 ? <div className="flex justify-center items-center h-8 w-8 rounded-full">{GlobalSVG.checked()}</div> : < div className="flex justify-center items-center h-8 w-8 rounded-full">
                4
              </div>
              }
            </div>
            <div className="flex-auto self-stretch my-auto text-black text-opacity-50">
              Serviços
            </div>
            <div className="flex justify-center items-center">
              {GlobalSVG.line(step > 4 ? "#389E0D" : null)}
            </div>
          </div>

          <div className="flex gap-2 items-center ">
            <div className={`flex justify-center items-center whitespace-nowrap aspect-square rounded-[32px] border border-solid ${step > 4 ? "text-black text-opacity-30 border-[color:var(--Polar-Green-7,#389E0D)]" : step === 4 ? "bg-lime-700 text-white border border-solid border-[color:var(--Polar-Green-7,#389E0D)]" : "text-black text-opacity-30"} `}>
              {step > 5 ? <div className="flex justify-center items-center h-8 w-8 rounded-full">{GlobalSVG.checked()}</div> : < div className="flex justify-center items-center h-8 w-8 rounded-full">
                5
              </div>
              }
            </div>
            <div className="flex-auto self-stretch my-auto text-black text-opacity-50">
              Checklist Obrigatório
            </div>
            <div className="flex justify-center items-center">
              {GlobalSVG.line(step > 4 ? "#389E0D" : null)}
            </div>
          </div>
          {/* <div className="flex gap-2 items-center w-auto">
            <div className={`flex justify-center items-center whitespace-nowrap aspect-square rounded-[32px] border border-solid ${step > 5 ? "text-black text-opacity-30 border-[color:var(--Polar-Green-7,#389E0D)]" : step === 5 ? "bg-lime-700 text-white border border-solid border-[color:var(--Polar-Green-7,#389E0D)]" : "text-black text-opacity-30"} `}>
              {step > 6 ? <div className="flex justify-center items-center h-8 w-8 rounded-full">{GlobalSVG.checked()}</div> : < div className="flex justify-center items-center h-8 w-8 rounded-full">
                6
              </div>
              }
            </div>
            <div className="grow my-auto text-black text-opacity-50">
              Gerar OS
            </div>
          </div> */}
        </div>}
      </div>
      {
        step === 1 ? <VehicleData nextStep={nextStep} /> :
          step === 2 ? <ClientData nextStep={nextStep} /> :
            step === 3 ? <InputChecklist nextStep={nextStep} /> :
              step === 4 ? <DetailedChecklist nextStep={nextStep} /> :
                step === 5 ? <Services nextStep={nextStep} /> :
                  step === 6 ? <OrderOfService nextStep={nextStep} /> : <></>}

    </div >
  );
}
export default CreateFastService; 